const jsum = require("jsum");

const generate = (json) => {
  const sha1 = jsum.digest(json, 'SHA1', 'hex');

  return sha1;
};

const validate = (checksum, data) => {
  const sha1 = generate(data);

  return checksum === sha1;
};

module.exports = {
  generate,
  validate
};
